import React from 'react';
import Icon from '@components/Icon';
import NetworkIcon from '@components/NetworkIcon';
import useGetNetworkName from '@hooks/useGetNetworkName';
import { Network } from '@types';

interface NetworkToNetworkInfoProps {
  from: Network;
  to: Network;
}

const NetworkToNetworkInfo = ({ from, to }: NetworkToNetworkInfoProps) => {
  const getNetworkName = useGetNetworkName();

  return (
    <div className="p-3 w-full text-white">
      <div className="flex flex-wrap content-center text-body pl-4 pr-4">
        <div className="text-left flex flex-row w-1/3 justify-end">
          <div className="text-heading2 h-full flex flex-wrap content-center">
            <NetworkIcon variant={from} />
          </div>
          <div className="ml-1 flex flex-col">
            <div className="text-micro">From</div>
            <div className="text-smallRegular">{getNetworkName(from)}</div>
          </div>
        </div>
        <div className="flex flex-wrap content-center w-1/3 justify-center">
          <Icon.ArrowNext className="text-heading3 text-white items-left" />
        </div>
        <div className="text-right flex flex-row w-1/3">
          <div className="text-heading2 h-full flex flex-wrap content-center">
            <NetworkIcon variant={to} />
          </div>
          <div className="ml-1 flex flex-col text-left">
            <div className="text-micro">To</div>
            <div className="text-smallRegular">{getNetworkName(to)}</div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default NetworkToNetworkInfo;
